mutation SupplierUploadDocument(
  $document: DocumentUploadInput!
  $supplierId: UUID!
) {
  supplierUploadDocument(document: $document, supplierId: $supplierId) {
    uploadLink
    document {
      _documentFileId
      supplierDocument {
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
      }
    }
  }
}
